import Component from '../core/Component'
import Flickity from 'flickity'

export const EMITS = {
    SLIDE_SELECTED: 'photoslider:selected'
}

export default class PhotoSlider extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            slider: null,
            items: []
        }

        this.flickity = null
    }

    prepare() {
        if (this.ref.items.length <= 1) {
            return
        }

        this.flickity = new Flickity(this.ref.slider, {
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            fade: true
        })

        this.flickity.on('change', this.handleSlideSelected)
    }

    handleSlideSelected = index => {
        this.emit(EMITS.SLIDE_SELECTED, {
            index
        })
    }

    resize() {
        this.flickity?.resize()
    }

    select(index) {
        this.flickity.select(index)
    }
}

